export const getSkuInformation = ({
  listPrice,
  tirelineName,
  tireSize,
  frontTireSize,
  frontTireListPrice
}) => {
  const isStaggeredFitment = Boolean(frontTireSize)

  return {
    tireLineName: tirelineName,
    price: `$${isStaggeredFitment ? frontTireListPrice : listPrice}`,
    tireSize: isStaggeredFitment ? frontTireSize : tireSize
  }
}
